/** Column definitions for registry-based reports ({ key, label }). */

export const EMPLOYEE_MASTER_REPORT_COLUMNS = [
    { key: 'emp_code', label: 'Employee Code' },
    { key: 'emp_name', label: 'Employee Name' },
    { key: 'client_id', label: 'Organization ID' },
    { key: 'unit_id', label: 'Branch ID' },
    { key: 'fatherOrHusband', label: 'Father Or Husband' },
    { key: 'gender', label: 'Gender' },
    { key: 'dob', label: 'Date Of Birth' },
    { key: 'mail_id', label: 'Mail Id' },
    { key: 'mobile_no', label: 'Mobile No' },
    { key: 'aadhaar_no', label: 'Aadhaar No' },
    { key: 'pan_no', label: 'PAN No' },
    { key: 'postal_add', label: 'Postal Address' },
    { key: 'per_add', label: 'Permanent Address' },
    { key: 'designation', label: 'Designation' },
    { key: 'natural_of_work', label: 'Nature Of Working' },
    { key: 'department', label: 'Department' },
    { key: 'emp_type', label: 'Employee Type' },
    { key: 'doj', label: 'Date Of Joining' },
    { key: 'esi_no', label: 'ESI No' },
    { key: 'pf_no', label: 'PF No' },
    { key: 'years_of_experiance', label: 'Years Of Experience' },
    { key: 'comp_worked_with', label: 'Companies Worked With' },
    { key: 'bank_Acc_No', label: 'Bank Account No' },
    { key: 'bank_ifsc', label: 'Bank IFSC' },
    { key: 'bank_name', label: 'Bank Name' },
    { key: 'bank_add', label: 'Bank Address' },
    { key: 'group_emp', label: 'Group' },
    { key: 'relay', label: 'Relay' },
    { key: 'shift_no', label: 'Shift Number' },
    { key: 'surname', label: 'Surname' },
    { key: 'place_of_birth', label: 'Place Of Birth' },
    { key: 'nationality', label: 'Nationality' },
    { key: 'uan', label: 'UAN' },
    { key: 'nominee', label: 'Nominee' },
    { key: 'remark', label: 'Remark' },
];

export const SALARY_REGISTER_REPORT_COLUMNS = [
    { key: 'emp_code', label: 'Employee Code' },
    { key: 'emp_name', label: 'Employee Name' },
    { key: 'client_id', label: 'Organization ID' },
    { key: 'unit_id', label: 'Branch ID' },
    { key: 'lop_days', label: 'LOP Days' },
    { key: 'paid_days', label: 'Paid Days' },
    { key: 'basic', label: 'Basic' },
    { key: 'hra', label: 'HRA' },
    { key: 'special_allowance', label: 'Special Allowance' },
    { key: 'DA', label: 'DA' },
    { key: 'conveyance', label: 'Conveyance' },
    { key: 'medical_allowance', label: 'Medical Allowance' },
    { key: 'ot', label: 'OT' },
    { key: 'nfh', label: 'NFH' },
    { key: 'maternityBenefit', label: 'Maternity Benefit' },
    { key: 'comp_others', label: 'Other Components' },
    { key: 'subsistanceAllowance', label: 'Subsistence Allowance' },
    { key: 'service_weightage', label: 'Service Weightage' },
    { key: 'st_bonus', label: 'Statutory Bonus' },
    { key: 'minimum_rates_of_wages_payable', label: 'Minimum Rates Of Wages Payable' },
    { key: 'total_production_in_case_of_piece_rate', label: 'Total Production (Piece Rate)' },
    { key: 'ot_date', label: 'OT Date' },
    { key: 'total_overtime_hours_worked', label: 'Total Overtime Hours Worked' },
    { key: 'arrears_from_last_month', label: 'Arrears From Last Month' },
    { key: 'wages_due', label: 'Wages Due' },
    { key: 'gross_salary', label: 'Gross Salary' },
    { key: 'ESI', label: 'ESI' },
    { key: 'PF', label: 'PF' },
    { key: 'PT', label: 'PT' },
    { key: 'TDS', label: 'TDS' },
    { key: 'LWF', label: 'LWF' },
    { key: 'society', label: 'Society' },
    { key: 'Insurance', label: 'Insurance' },
    { key: 'damages_loss', label: 'Damages Loss' },
    { key: 'salary_advance', label: 'Salary Advance' },
    { key: 'fines', label: 'Fines' },
    { key: 'Act_of_Commission', label: 'Act Of Commission' },
    { key: 'Cause_Against_Fine', label: 'Cause Against Fine' },
    { key: 'Fine_Imposed_Date', label: 'Fine Imposed Date' },
    { key: 'Fine_Realized_Date', label: 'Fine Realized Date' },
    { key: 'others', label: 'Others' },
    { key: 'total_deduction', label: 'Total Deduction' },
    { key: 'net_pay', label: 'Net Pay' },
    { key: 'mode_of_pay', label: 'Mode Of Pay' },
];


export const CTC_MASTER_REPORT_COLUMNS = [
    { key: "emp_code", label: "Employee Code"},
    { key: "emp_name", label: "Employee Name"},
    { key: "client_id", label: "Organization ID"},
    { key: "unit_id", label: "Branch ID"},
    { key: "current_month", label: "Current Month" },
    { key: "effective_date", label: "Effective Date" },
    { key: "basic", label: "Basic" },
    { key: "special_allowance", label: "Special Allowance"},
    { key: "DA", label: "DA" },
    { key: "hra", label: "HRA" },
    { key: "st_bonus", label: "ST Bonus" },
    { key: "subsistanceAllowance", label: "Subsistance Allowance" },
    { key: "medical_allowance", label: "Medical Allowance" },
    { key: "maternityBenefit", label: "Maternity Benefit" },
    { key: "nfh", label: "NFH" },
    { key: "ot", label: "OT" },
    { key: "service_weightage", label: "Service Weightage" },
    { key: "society", label: "Society" },
    { key: "salary_advance", label: "Salary Advance" },
    { key: "conveyance", label: "Conveyance" },
    { key: "comp_others", label: "Comp Others" },
    { key: "gross_salary", label: "Gross Salary" },
    { key: "ESI", label: "ESI" },
    { key: "PF", label: "PF" },
    { key: "PT", label: "PT" },
    { key: "TDS", label: "TDS" },
    { key: "Insurance", label: "Insurance" },
    { key: "damages_loss", label: "Damages Loss" },
    { key: "fines", label: "Fines" },
    { key: "LWF", label: "LWF" },
    { key: "others", label: "Others" },
    { key: "total_deduction", label: "Total Deduction" },
    { key: "net_pay", label: "Net Pay" },
    { key: "mode_of_pay", label: "Mode Of Payment" },
    // { key: "p_month", label: "Payment Month" },
];



export const SALARY_ADVANCES_REPORT_COLUMNS = [
    { key: "emp_code", label: "Employee Code"},
    { key: "unit_id", label: "Branch ID"},
    { key: "client_id", label: "Organization ID"},
    { key: "current_month", label: "Current Month"},
    { key: "date_of_advance_made", label: "Date of Advance Made"},
    { key: "amount_of_advance_made", label: "Amount of Advance Made"},
    { key: "purpose_advance_made", label: "Purpose of Advance Made"},
    { key: "number_of_instalments_advance_repaid", label: "Number of Instalments Repaid"},
    { key: "postponements", label: "Postponements"},
    { key: "granted", label: "Granted"},
    { key: "date_total_on_amount_repaid", label: "Date Total on Amount Repaid"},
    { key: "remarks", label: "Remarks"},
];


export const OTHER_INPUTS_REPORT_COLUMNS = [
    { key: "emp_code", label: "Employee Code"},
    { key: "unit_id", label: "Branch ID"},
    { key: "client_id", label: "Organization ID"},
    { key: "current_month", label: "Current Month"},
    { key: "tn_form_I_date_on_Which_he_made_permanent", label: "Date on Which he made permanent"},
];


export const Leave_Register_REPORT_COLUMNS = [
    { key: "emp_code", label: "Employee Code" },
    { key: "leave_code", label: "Leave Code"},
    { key: "unit_id", label: "Branch ID"},
    { key: "client_id", label: "Organization ID"},
    { key: "current_month", label: "Current Month"},
    { key: "leave_applied_date", label: "Leave Applied Date"},
    { key: "leave_from", label: "Leave From"},
    { key: "leave_to", label: "Leave To"},
    { key: "total_days", label: "Total Days"},
    { key: "leave_type", label: "Leave Type" },
    { key: "part_of_day", label: "Part of Day"},
    { key: "reason", label: "Reason"},
];


export const ATTENDANCE_OVERRIDE_COLUMNS =  [
    { key: "emp_code", label: "Employee Code" },
    { key: "emp_Name", label: "Employee Name" },
    { key: "client_id", label: "Organization ID"},
    { key: "unit_id", label: "Branch ID" },
    { key: "sick_leaves_opening_balance", label: "Sick Leaves Opening Balance" },
    { key: "sick_leave_eligible_for_month", label: "Sick Leave Eligible For The Month" },
    { key: "sick_leave_total_available", label: "Sick Leave Total Available" },
    { key: "sick_leaves_taken", label: "Sick Leaves Taken" },
    { key: "sick_leave_balance", label: "Sick Leave Balance" },
    { key: "paid_leaves_opening_balance", label: "Paid Leaves Opening Balance" },
    { key: "paid_leave_eligible_for_month", label: "Paid Leave Eligible for Month" },
    { key: "paid_leave_total_available", label: "Paid Leave Total Available" },
    { key: "paid_leaves_taken", label: "Paid Leaves Taken" },
    { key: "paid_leave_balance", label: "Paid Leave Balance" },
    { key: "maternity_leave", label: "Maternity Leave" },
    { key: "casual_leave_eligible_for_month", label: "Casual Leave Eligible for Month" },
    { key: "casual_leaves_opening_balance", label: "Casual Leaves Opening Balance" },
    { key: "casual_leaves_taken", label: "Casual Leaves Taken" },
    { key: "casual_leave_balance", label: "Casual Leave Balance" },
    { key: "casual_leave_total_available", label: "Casual Leave Total Available"},
    { key: "total_leave_days", label: "Total Leave Days" },
];


export const MATERNITY_BENEFITS_COLUMNS = [
    { key: "emp_code", label: "Employee Code"},
    // { key: "id", value: "Record ID", input: "number" },
    { key: "unit_id", label: "Branch ID"},
    { key: "client_id", label: "Organization ID"},
    { key: "current_month", label: "Current Month"},
    { key: "employee_name", label: "Employee Name"},
    { key: "establishment_name", label: "Establishment Name" },
    { key: "work_nature", label: "Work Nature" },
    { key: "father_or_husband_name", label: "Father/Husband Name" },
    { key: "appointment_date", label: "Appointment Date"},
    { key: "advance_maternity_benefit_amount", label: "Advance Maternity Benefit Amount"},
    { key: "advance_maternity_benefit_date", label: "Advance Maternity Benefit Date" },
    { key: "bonus_payment_amount_sec8", label: "Bonus Payment Amount (Sec 8)" },
    { key: "bonus_payment_date_sec8", label: "Bonus Payment Date (Sec 8)"},
    { key: "child_birth_date", label: "Child Birth Date"},
    { key: "child_survives_benefit_period", label: "Child Survives Benefit Period" },
    { key: "child_survives_benefit_recipient", label: "Child Survives Benefit Recipient" },
    { key: "death_benefit_amount", label: "Death Benefit Amount"},
    { key: "death_benefit_recipient", label: "Death Benefit Recipient" },
    { key: "delivery_miscarriage_death_proof_date", label: "Delivery/Miscarriage Death Proof Date" },
    { key: "discharge_dismissal_date", label: "Discharge/Dismissal Date", input: "date" },
    { key: "illness_leave_wages_amount_sec10", label: "Illness Leave Wages Amount (Sec 10)"},
    { key: "illness_leave_wages_date_sec10", label: "Illness Leave Wages Date (Sec 10)"},
    { key: "illness_proof_date_sec10", label: "Illness Proof Date (Sec 10)" },
    { key: "leave_wages_payment_amount_sec9", label: "Leave Wages Payment Amount (Sec 9)"},
    { key: "leave_wages_payment_date_sec9", label: "Leave Wages Payment Date (Sec 9)"},
    { key: "notice_date_sec6", label: "Notice Date (Sec 6)"},
    { key: "pregnancy_proof_date_sec6", label: "Pregnancy Proof Date (Sec 6)"},
    { key: "subsequent_maternity_benefit_amount", label: "Subsequent Maternity Benefit Amount"},
    { key: "subsequent_maternity_benefit_date", label: "Subsequent Maternity Benefit Date"},
    { key: "woman_death_date", label: "Woman Death Date"},
    { key: "employer_signature", label: "Employer Signature"},
    { key: "employment_status_header_names", label: "Employment Status Header Names" },
    { key: "employment_status_header_values", label: "Employment Status Header Values" },
    { key: "inspector_remarks", label: "Inspector Remarks"},
];

export const  TN_FORM_VI_COLUMNS =  [
{ key: "emp_code", label: "Employee Code" },
{ key: "emp_name", label: "Employee Name" },
{ key: "father_or_husband", label: "Father or Husband Name"},
{ key: "unit_id", label: "Branch ID"},
{ key: "client_id", label: "Organization ID"},
{ key: "work_on_double_wages_date", label: "Work on Double Wages Date"},
{ key: "work_with_substituted_holiday_date", label: "Work With Substituted Holiday Date"},
{ key: "current_year", label: "Current Year"}
];


export const EMPLOYEE_SEPARATION_REPORT_COLUMNS = [
    { key: "emp_code", label: "Employee Code" },
    { key: "client_id", label: "Organization ID"},
    { key: "unit_id", label: "Branch ID"},
    { key: "emp_separation_date", label: "Employee Separation Date"},
    { key: "emp_separation_reason", label: "Employee Separation Reason"},
    { key: "separation_current_month", label: "Employee Separation Current Month"},
];


export const STAFFING_AGENCIES_REPORT_COLUMNS = [
    { key: "contractor_code", label: "Contractor Code" },
    { key: "contractor_name", label: "Contractor Name" },
    { key: "client_id", label: "Organization ID"},
    { key: "unit_id", label: "Branch ID"},
    { key: "current_month", label: "Current Month"},
    { key: "contractor_address", label: "Contractor Address"},
    { key: "principal_employer_name", label: "Principal Employer Name"},
    { key: "principal_employer_address", label: "Principal Employer Address" },
    { key: "nature_of_work", label: "Nature of Work" },
    { key: "work_location", label: "Work Location"},
    { key: "contract_from_date", label: "Contract From Date" },
    { key: "contract_to_date", label: "Contract TO Date" },
    { key: "max_workmen", label: "Maximum Number of Workmen" },
];

export const LEAVE_OPENING_BALANCE_REPORT_COLUMNS = [
    { key: "emp_code", label: "Employee Code"},
    { key: "emp_name", label: "Employee Name"},
    { key: "unit_id", label: "Branch ID"},
    { key: "client_id", label: "Organization ID"},
    { key: "current_month", label: "Current Month"},
    { key: "paid_leaves_opening_balance", label: "Paid Leave Opening Balance"},
    { key: "sick_leaves_opening_balance", label: "Sick Leave Opening Balance"},
    { key: "maternity_leave", label: "Maternity Leave"},
    { key: "casual_leaves_opening_balance", label: "Casual Leave Opening Balance"},
    // { key: "emergency_leave_opening_balance", label: "Emergency Leave Opening Balance", input: 'number'},
];

export const EMPLOYEE_TRANSFER_REPORT_COLUMNS = [
    { key: 'emp_code', label: 'Employee Code' },
    { key: 'emp_name', label: 'Employee Name' },
    { key: 'client_id', label: 'Organization ID' },
    { key: 'from_unit_id', label: 'From Branch' },
    { key: 'to_unit_id', label: 'To Branch' },
    { key: 'transfer_date', label: 'Transfer Date' },
];



export const CLIENT_BACKUP_REPORT_COLUMNS = [
    // { key: 'backup_id', label: 'Backup ID' },
    // { key: 'effective_to', label: 'Effective To' },
    // { key: 'changed_fields_display', label: 'Changed Fields' },
    // { key: 'company_code', label: 'Company Code' },
    { key: 'client_id', label: 'Organization ID' },
    { key: 'client_name', label: 'Organization Name' },
    { key: 'effective_from', label: 'Effective From' },
    { key: 'state_name', label: 'State' },
    { key: 'No_of_Branchs', label: 'No Of Branches' },
    { key: 'Address', label: 'Address' },
    { key: 'Headcount_Male', label: 'Headcount Male' },
    { key: 'Headcount_Female', label: 'Headcount Female' },
    { key: 'Headcount_Transgender', label: 'Headcount Transgender' },
    { key: 'NatureOfWork', label: 'Nature Of Work' },
    { key: 'Name_of_Employer', label: 'Name Of Employer' },
    { key: 'pan_or_tan_of_the_employer', label: 'PAN/TAN' },
    { key: 'lin', label: 'LIN' },
    { key: 'Telephone_No', label: 'Telephone' },
    { key: 'Email_ID', label: 'Email' },
    { key: 'Date_of_Incorporation', label: 'Date Of Incorporation' },
    { key: 'WorkingHours', label: 'Working Hours' },
    { key: 'BreakTime', label: 'Break Time' },
    { key: 'WeeklyHoliday', label: 'Weekly Holiday' },
    { key: 'SalaryDate', label: 'Salary Date' },
    { key: 'Authorised_Seal', label: 'Authorised Seal' },
    { key: 'AuthorisedSignatory', label: 'Authorised Signatory' },
    // { key: 'status', label: 'Status' },
    // { key: 'deactive_date', label: 'Deactive Date' },
    { key: 'TotalUnits', label: 'Total Units' },
    // { key: 'backup_created_at', label: 'Backup Created At' },
    // { key: 'backup_created_by', label: 'Backup Created By' },
    // { key: 'created_at', label: 'Master Created At' },
    // { key: 'created_by', label: 'Master Created By' },
    // { key: 'updated_at', label: 'Master Updated At' },
    // { key: 'updated_by', label: 'Master Updated By' },
];


export const UNIT_BACKUP_REPORT_COLUMNS = [
    { key: "unit_id", label: "Branch ID"},
        { key: "unit_name", label: "Branch Name"},
        { key: "client_id", label: "Organization ID" },
        { key: "client_name", label: "Organization Name"},
        { key: "effective_from", label: "Effective From" },
        { key: "state", label: "State Name" },
        { key: "Location_City", label: "Location/City" },
        { key: "Address", label: "Address" },
        { key: "Unit_Start_Date", label: "Branch Start Date" },
        { key: "Telephone_No", label: "Telephone No"},
        { key: "Headcount_Male", label: "Headcount Male" },
        { key: "Headcount_Female", label: "Headcount Female" },
        { key: "Headcount_Transgender", label: "Headcount Transgender" },
        // { key: "NatureOfWork", value: "Nature Of Work",input:"text" },
        { key: "Email_ID", label: "Email ID" },
        { key: "WorkingHours", label: "Working Hours" },
        { key: "BreakTime", label: "Break Time" },
        { key: "WeeklyHoliday", label: "Weekly Holiday" },
        { key: "Select_leave_codes", label: "Select Leave Codes" },
        { key: "SnE_No", label: "S&E No",input:"text" },
        { key: "SnE_Validity", label: "S&E Validity" },
        { key: "CLEARC", label: "CLRARC" },
        { key: "CLRARC_Validity", label: "CLRARC Validity" },
        { key: "CLRALicense", label: "CLRA License" ,input:"text"},
        { key: "CLRALicense_Validity", label: "CLRA License Validity" },
        { key: "SalaryDate", label: "Salary Date" },
        { key: "AuthorisedSignatory", label: "Authorised Signatory" },
        { key: "Authorised_Seal", label: "Authorised Seal" },
];